import { useEffect, useState } from "react";

const KEY = "cpt.unit_system";

// Conversion helpers
export const G_PER_OZ = 28.3495231;
export const G_PER_LB = 453.5924;

export function gToDisplay(grams, system) {
  if (grams === null || grams === undefined || isNaN(grams)) return { value: null, unit: system === "us" ? "oz" : "g" };
  if (system === "us") {
    if (grams >= G_PER_LB * 0.75) return { value: grams / G_PER_LB, unit: "lb" };
    return { value: grams / G_PER_OZ, unit: "oz" };
  }
  if (grams >= 1500) return { value: grams / 1000, unit: "kg" };
  return { value: grams, unit: "g" };
}

// Convert a user-entered value in the current display unit back to grams
export function displayToG(value, system) {
  const n = parseFloat(value);
  if (isNaN(n)) return 0;
  return system === "us" ? n * G_PER_OZ : n;
}

export function fmtWeight(grams, system, decimals) {
  const d = gToDisplay(grams, system);
  if (d.value === null) return "—";
  const dec = decimals !== undefined ? decimals : (d.unit === "kg" || d.unit === "lb" ? 2 : 1);
  return `${d.value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: dec })}${d.unit}`;
}

export function useUnitSystem() {
  const [system, setSystem] = useState(() => {
    try { return localStorage.getItem(KEY) || "metric"; } catch { return "metric"; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, system); } catch {}
  }, [system]);
  return [system, setSystem];
}

export function UnitToggle({ system, onChange, testid = "unit-toggle" }) {
  return (
    <div className="inline-flex rounded-full border border-[#EBDCD1] p-0.5 bg-white" data-testid={testid}>
      {[
        { key: "metric", label: "Metric (g)" },
        { key: "us",     label: "US (oz/lb)" },
      ].map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition ${
            system === o.key ? "bg-[#3B2C24] text-white" : "text-[#857163] hover:text-[#3B2C24]"
          }`}
          data-testid={`unit-${o.key}`}
        >{o.label}</button>
      ))}
    </div>
  );
}
